import { Relref } from 'assets/ts/hugo';
import axios from 'smg/axios';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as html from 'smg/html';
import * as phone from 'smg/phone';
import { G } from 'smg/querystring';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import { FullName } from 'smg/users';

declare interface myWindow extends Window {
    readonly cloudFront?: string;
}
declare const window: myWindow;

if (document.body.id === 'free-quote-thank-you') {
    void main();
}

async function main() {
    if (G().Get('inDepth') === 'true') {
        const $stepInDepth = document.querySelector('.free-quote-progress-step-in-depth') as HTMLElement;
        $stepInDepth.classList.remove('d-none');
        $stepInDepth.nextElementSibling?.classList.remove('d-none');
    }

    const quotes = await axios.get<hyejoo.Quotes>('/v2/quotes', {
        params: {
            'data': 'serial,quoteRequest,quoteLineItems',
            'q': `key:${G().Get('id') ?? ''}`,
        },
    }).then(resp => resp.data.quotes);

    if (!quotes.length) {
        window.location.href = Relref('/free-quote');
        return;
    }

    const quote = quotes[0];

    const $email = document.querySelectorAll<HTMLElement>('.free-quote-email');
    $email.forEach($ => {
        $.textContent = quote.quoteRequest?.email ?? '';
    });

    const $serial = document.querySelector('#free-quote-serial') as HTMLElement;
    $serial.textContent = quote.serial ?? '';

    const $phone = document.querySelector('#free-quote-phone') as HTMLElement;
    $phone.textContent = phone.Human(quote.quoteRequest?.phone ?? '');

    const $name = document.querySelector('#free-quote-name') as HTMLElement;
    $name.textContent = FullName({ firstName: quote.quoteRequest?.firstName, lastName: quote.quoteRequest?.lastName });

    const $company = document.querySelector('#free-quote-company') as HTMLElement;
    $company.textContent = quote.quoteRequest?.company ?? '';

    const $designContainer = document.querySelector('#free-quote-design-container') as HTMLElement;
    const $frontContainer = document.querySelector('#free-quote-design-front-container') as HTMLElement;
    const $frontUploadsContainer = document.querySelector('#free-quote-design-front-uploads-container') as HTMLElement;
    const $frontUploads = document.querySelector('#free-quote-basic-details-front-uploads') as HTMLElement;
    const $frontNotesContainer = document.querySelector('#free-quote-design-front-notes-container') as HTMLElement;
    const $frontNotes = document.querySelector('#free-quote-basic-details-front-notes') as HTMLElement;

    if (quote.quoteRequest?.quoteRequestUploads) {
        $designContainer.classList.remove('d-none');
        $frontContainer.classList.remove('d-none');
        $frontUploadsContainer.classList.remove('d-none');

        quote.quoteRequest.quoteRequestUploads.forEach(quoteRequestUpload => {
            const u = quoteRequestUpload.upload;

            const $thumb = html.FromString(`
                <div class="uploader-thumbnail">
                    <a class="uploader-thumbnail-img-link" href="#" data-fancybox="free-quote-upload-front">
                        <div class="uploader-thumbnail-img-link-spinner-parent">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <img class="uploader-thumbnail-img" src="" style="max-height:100px;max-width:100px" alt="" title="" crossorigin="crossorigin">
                    </a>
                    <div class="d-flex">
                        <div class="uploader-thumbnail-name flex-grow-1 text-truncate" style="max-width:100px"></div>
                    </div>
                </div>`);

            const $a = $thumb.querySelector('.uploader-thumbnail-img-link') as HTMLAnchorElement;
            const $img = $thumb.querySelector('.uploader-thumbnail-img') as HTMLImageElement;
            const $name = $thumb.querySelector('.uploader-thumbnail-name') as HTMLElement;

            $a.href = `${window.cloudFront ?? ''}/${u?.key ?? ''}`;
            $a.setAttribute('data-caption', u?.name ?? '');

            void uploads.Load($img, `${window.cloudFront ?? ''}/${u?.key ?? ''}`, u?.name ?? '').then(success => {
                if (!success) {
                    $thumb.classList.add('uploader-thumbnail--no-preview');
                }
            });

            $name.innerText = u?.name ?? '';
            $name.title = u?.name ?? '';

            $frontUploads.appendChild($thumb);

            $thumb.classList.remove('uploader-thumbnail--loading');
            $thumb.querySelector('.uploader-thumbnail-img-link-spinner-parent')?.remove();
        });
    }

    const frontNotes = quote.quoteRequest?.notesObj?.['Front'] || quote.quoteRequest?.notesObj?.['Notes'];

    if (frontNotes && typeof frontNotes === 'string') {
        $designContainer.classList.remove('d-none');
        $frontContainer.classList.remove('d-none');
        $frontNotesContainer.classList.remove('d-none');
        $frontNotes.textContent = frontNotes;
    }

    const $notesDetailsParent = document.querySelector('#free-quote-notes-details-parent') as HTMLElement;
    const $notesDetailTemplate = document.querySelector('#free-quote-notes-detail-template') as HTMLTemplateElement;
    if (quote.quoteRequest?.notesObj) {
        for (const detail of Object.keys(quote.quoteRequest.notesObj)) {
            const $detail = template.Clone($notesDetailTemplate).firstElementChild as HTMLElement;
            const $name = $detail.querySelector('.free-quote-notes-detail-name') as HTMLElement;
            const $value = $detail.querySelector('.free-quote-notes-detail-value') as HTMLElement;

            let detailName = detail;
            switch (detail) {
            case 'Notes':
                continue;
            case 'LineItem':
                detailName = 'Product';
                break;
            }

            $name.textContent = detailName;
            $value.textContent = String(quote.quoteRequest.notesObj[detail]);

            $notesDetailsParent.appendChild($detail);
        }
    }

    const $spinner = document.querySelector('#free-quote-spinner-parent') as HTMLElement;
    const $content = document.querySelector('#free-quote-content') as HTMLElement;
    $spinner.remove();
    $content.classList.remove('d-none');
}